// The cash-management "server_directory" (default ".\logMonnayeur") was being
// JSON-escaped on write without being un-escaped on read, so its backslashes
// doubled on every modify/associate: ".\logMonnayeur" -> ".\\logMonnayeur" ->
// ".\\\\logMonnayeur" ... Collapse any run of backslashes back to a single one
// so the value is idempotent across save/read cycles and self-heals.
// NOTE: intentionally does NOT preserve a UNC "\\server\share" prefix — this
// field is a local log directory on the coin machine, never a network share.
export function normalizeServerDirectory(value: unknown): string {
    if (typeof value !== "string") return "";
    return value.replace(/\\+/g, "\\");
}
